import ApiService from '.';
import { EditMemberParams, SendInviteParams } from '../params/redux/team';

/**
 * @heading1: Task API service.
 * @paragraph: This module provides a set of methods to interact with the Task API.
 * It handles operations like Fetching tasks, add task, edit task etc.
 */

const TeamApi = {
    /**
     * @heading3: Fetch Tasks
     * @paragraph: Sends a GET request to retrieve all tasks available for the user.
     * @param: {string} token - The user's authentication token.
     * @returns: {Promise<unknown[]>} - The response containing a list of all tasks.
     * @separator:
     */
    fetchTeams: (token: string) => {
        // Perform a GET request to fetch tasks
        return ApiService.apiHit({
            url: 'get-team',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    /**
     * @heading3: Fetch Due Task List
     * @paragraph: Sends a POST request to fetch due task list.
     * @param: {string} token - The user's authentication token, required for authorization.
     * @param: {number} client_id - The client_id required for the operation.
     * @returns: {Promise<unknown[]>} - A promise that resolves to the response containing the operation result.
     * @separator:
     */
    sendInvite: (token: string, data: SendInviteParams) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'send-company-invitation',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    deleteMember: (token: string, user_id: number) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'delete-team-member',
            method: 'post',
            token,
            data: { user_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    editMember: (token: string, data: EditMemberParams) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'edit-team-member',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default TeamApi;
